import {
  ApiSlugs,
  ListPagination,
  TokenVaultFilterKey,
  TokenVaultId,
  TokenVaultSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserTokenVaultsAdminConnector extends ApiConnector<
  TokenVaultSummaryDto,
  TokenVaultSummaryDto,
  TokenVaultId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.TOKEN_VAULTS}`);
  }

  list(pagination?: ListPagination<TokenVaultFilterKey>): Observable<TokenVaultSummaryDto[]> {
    return this.apiCaller.getRequest<TokenVaultSummaryDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );
  }

  count(pagination?: ListPagination<TokenVaultFilterKey>): Observable<number> {
    return this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );
  }
}
